import { useEffect, useState } from "react";
import moment from 'moment';

// Filter definitions
const textColumns = [
    "alert",
    "name",
    "description",
    "first",
    "last",
    "location",
    "inventory",
    "siteName",
    "owner",
    "name",
    "email",
    "title",
    // "assignee",
    "assignee_name",
    "last-action",
    "task",
    "folder_name"
]
// const siteColumn = ["site", "sites"]
// const dateColumns = [
//     "last-action-date",
//     "last-modified",
//     "date-created",
//     "start-date",
//     "end-date",
//     "enacted-date",
//     "expiration-date",
//     "created",
//     "revised",
//     "expires",
//     "requested",
//     "completed"
// ]
// const statusColumn = ["All", "Pending", "Approved", "Denied"]
const typeColumns = [
    {
        type: "agreement-type",
        options: ["All", "Confidentiality", "Business Associate"]
    },
    { "affiliate-type": [] }
]
// User roles are stored as 8-bit integers, so we map them to the labels both here and in the tableDef
// const rolesColumn = {
//     All: 0,
//     "Regular User": 1,
//     Admin: 127,
//     SuperUser: 255
// }

// const userStatusColumn = {
//     "Awaiting Registation": -1,
//     Inactive: 0,
//     Active: 1
// }

// const lastActionColumn = [
//     "All",
//     "Questionnaire completed",
//     "Agreement sent",
//     "Agreement attested",
//     "Questionnaire awaiting assignment",
//     "Questionnaire reviewed & attested",
//     "Affiliate created"
// ]

function useFilterRows(filters, rowsData) {
    const [filteredRows, setFilteredRows] = useState(rowsData)

    useEffect(() => {
        // console.log("filters are", filters)
        let result

        // If there are any filters
        if (Object.values(filters).some(value => value)) {
            // Filter the rows
            result = rowsData && rowsData.reduce((rows, row) => {
                // Only test row if there is a filter
                // Support multiple filters
                if (
                    (!filters.text || testRow(row, "text", filters)) &&
                    (!filters.type || testRow(row, "type", filters)) &&
                    (!filters["last-action"] || testRow(row, "last-action", filters)) &&
                    (!filters.status || testRow(row, "status", filters)) &&
                    (!filters.start || testRow(row, "start", filters)) &&
                    (!filters.site || testRow(row, "site", filters)) &&
                    (!filters.end || testRow(row, "end", filters)) &&
                    (!filters.role || testRow(row, "role", filters)) &&
                    (!filters.role_str || testRow(row, "role_str", filters)) &&
                    (!filters.folder_name || testRow(row, "folder_name", filters))
                )
                    return rows.concat(row)
                else return rows
            }, [])
            setFilteredRows(result)
        } else setFilteredRows(rowsData)
    }, [filters, rowsData])

    return filteredRows
}

function testRow(row, filter, filters) {
    try {
        // Test textual fields
        if (filter === "text" && filters.text) {
            return Object.keys(row).some(key => {
                if (textColumns.includes(key)) {
                    return row[key].search(new RegExp(filters.text, "i")) >= 0
                }
                return false;
            });
        }

        // Test type
        if (filter === "type" && filters.type)
            return Object.keys(row).some(key => {
                if (typeColumns.some(({ type }) => type === key)) {
                    return filters.type === "All"
                        ? 1
                        : row[key] === filters.type
                }
                return false;
            })

        // Test last-action
        if (filter === "last-action" && filters["last-action"])
            return Object.keys(row).some(key => {
                if (key === "last-action") {
                    return filters["last-action"] === "All"
                        ? 1
                        : row[key] === filters["last-action"]
                }
                return false;
            })

        // Test status
        if (filter === "status" && filters["status"])
            return Object.keys(row).some(key => {
                if (key === "status") {
                    return filters.status === "All"
                        ? 1
                        : row[key] === filters.status
                }
                return false;
            })

        // Test start
        if (filter === "start" && filters["start"] && filters["dateField"]) {
            if (moment(row[filters["dateField"]], 'YYYY-MM-DD').isSameOrAfter(filters.start)) {
                return 1;
            }
            return false;
        }

        // Test end
        if (filter === "end" && filters["end"] && filters["dateField"]) {
            if (moment(row[filters["dateField"]], 'YYYY-MM-DD').isSameOrBefore(filters.end)) {
                return 1;
            }
            return false;
        }

        // Test site
        if (filter === "site" && filters["site"]) {
            if (filters.selected_sites.length === 0) {
                return true;
            }
            return filters.selected_sites.includes(row.site) ? true : false;
        }

        // Test role
        if (filter === "role" && filters["role"])
            if (filters["role"] === "All") {
                return true
            } else {
                return row.role_str === filters["role"] ? 1 : 0;
            }


        if (filter === "role_str" && filters["role_str"])
            return row.role_str === filters["role_str"] ? 1 : 0;

        if (filter === "folder_name" && filters["folder_name"])
            return row.folder_name === filters["folder_name"] ? 1 : 0;
                
    } catch (err) {
        console.log("Error while filtering", err)
        return 0
    }
}

export default useFilterRows
